<script lang="ts">
  import type { Emodel } from "../../helpers/types";
  import SearchIcon from "../icons/SearchIcon.svelte";
  import SmartControlList from "../molecules/SmartControlList.svelte";
  import SmartControlSearchList from "../molecules/SmartControlSearchList.svelte";

  interface Props {
    eModels: Emodel[];
    searchPlaceholder: string;
    showList: boolean;
  }

  let { eModels, searchPlaceholder = $bindable(), showList }: Props = $props();

  searchPlaceholder = searchPlaceholder || "Sök";

  let search = $state("");

  let filteredModels = $state(eModels);

  const onSearch = (): void => {
    const searchQuery = search.toLowerCase().trim();

    filteredModels = eModels.filter((model) => {
      return (
        model.manufacturer.label.toLowerCase().includes(searchQuery) ||
        model.fullname.toLowerCase().includes(searchQuery)
      );
    });
  };
</script>

<section class="mb-4">
  <div class="relative mb-2">
    <div class="absolute inset-y-0 left-0 flex pl-4 items-center pointer-events-none">
      <SearchIcon class="text-PurplePrimary" />
    </div>
    <input
      type="text"
      class="bg-Neutral300 placeholder-Purple700 text-PurplePrimary focus:ring-0 text-H3 rounded-lg block w-full pl-16 py-4"
      placeholder={searchPlaceholder}
      bind:value={search}
      oninput={onSearch}
    />
  </div>
  {#if showList}
    <SmartControlList eModels={filteredModels} />
  {:else if search}
    <SmartControlSearchList eModels={filteredModels} />
  {/if}
</section>
